module.exports = __webpack_public_path__ + "amelia.4b6ac60c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/mocks/amelia.png
// module id = 2562
// module chunks = 0